import { Circle, Wedge } from "react-konva";
import { currentSightDirection } from "../../../lib/visibility";

// Weapon reach ring (your own selected token's longest attack range + enemies caught inside it)
// and NPC sight-cone wedges (only visible to the GM or a player currently "hunted" by that NPC),
// extracted verbatim from MapCanvas.jsx (Phase 42 refactor) — no behavior changes.
export function MapCombatOverlays({ showReachRing, selectedToken, reachRadiusPx, reachRangeFt, tokens, isGm, myMemberId, gridSize }) {
  return (
    <>
      {showReachRing && reachRangeFt > 0 && (
        <>
          <Circle
            x={selectedToken.x}
            y={selectedToken.y}
            radius={reachRadiusPx}
            stroke="#D90429"
            strokeWidth={1.5}
            dash={[8, 5]}
            opacity={0.4}
            listening={false}
            data-testid={`weapon-reach-ring-${selectedToken.id}`}
          />
          {tokens
            .filter((t) => t.token_type === "npc" && t.id !== selectedToken.id && (t.hp_current == null || t.hp_current > 0) && Math.hypot(t.x - selectedToken.x, t.y - selectedToken.y) <= reachRadiusPx)
            .map((t) => (
              <Circle key={`in-reach-${t.id}`} x={t.x} y={t.y} radius={(t.size || 50) / 2 + 6} stroke="#D90429" strokeWidth={2.5} listening={false} data-testid={`in-reach-highlight-${t.id}`} />
            ))}
        </>
      )}
      {tokens.filter((t) => t.sight_cone_enabled).map((t) => {
        const hunting = (t.looking_for_member_ids || []).includes(myMemberId);
        if (!isGm && !hunting) return null;
        const radius = ((t.sight_range_ft || 60) / 5) * gridSize;
        const direction = currentSightDirection(t);
        const angle = t.sight_angle_deg || 90;
        const color = hunting ? "#D90429" : "#D4AF37";
        return (
          <Wedge
            key={`sight-${t.id}`}
            x={t.x}
            y={t.y}
            radius={radius}
            angle={angle}
            rotation={direction - angle / 2}
            fill={color}
            opacity={hunting ? 0.22 : 0.1}
            stroke={color}
            strokeWidth={1.5}
            listening={false}
            data-testid={`sight-cone-${t.id}`}
          />
        );
      })}
    </>
  );
}
